import {
    Modal,
    Space,
} from "antd";
import CTable from "../table/CTable";
import './CModalUserList.styles.scss';

interface MyProps {
    open: boolean;
    data: any[];
    totalRecord: number;
    onCancel: () => void;
    onChangePagination: (page: number) => void;
}

const CModalUserList = (props: MyProps) => {
    const columns = [
        {
            title: "Tên người dùng",
            dataIndex: "name",
            key: "name",
            render: (text: any, record: any) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {record.user.username}
                    </div>
                );
            }
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
            render: (text: any, record: any) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {record.user.phoneNumber}
                    </div>
                );
            }
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text: any, record: any) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {record.user.email}
                    </div>
                );
            }
        },
    ];

    return (
        <Modal
            open={props.open}
            title={
                <Space>
                    <span>Danh sách người dùng đã mua</span>
                </Space>
            }
            onCancel={props.onCancel}
            footer={null}
            width={1000}
            className="user-list-modal"
            destroyOnClose
            maskClosable={true}
        >
            <div className="modal-content">
                <CTable
                    tableMainTitle=""
                    allowTextSearch={false}
                    onChangeInput={() => { }}
                    onSearch={() => { }}
                    titleOfColumnList={columns}
                    data={props.data}
                    totalRecord={props.totalRecord}
                    onChangePagination={props.onChangePagination}
                    allowAddObject={false}
                    textSearch=""
                    pageSize={10}
                    size={400}
                />
            </div>
        </Modal>
    );
};

export default CModalUserList; 